import React from "react";

type IconButtonProps = {
  label?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
};

const IconButton = ({ label, className, onClick, children }: IconButtonProps) => {
  return (
    <button
      title={label}
      className={`w-9 h-9 rounded-lg flex items-center justify-center border border-gray-200 hover:bg-gray-50 text-gray-700 ${
        className || ""
      }`}
      onClick={onClick}
    >
      {children || <span>⋯</span>}
    </button>
  );
};

export default IconButton;
